import React, { Component } from 'react'
import './NavbarCSS.css'
import Logo from '../Images/Logo.png'
import { Link } from 'react-router-dom'
import Navbutton from '../Images/NavButton.png'

export default class Navbar extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
       tab : false
    }
  }
  handleTab =()=>{
    this.setState({
      tab:!this.state.tab
    })
  }
  render() {
    return (
      <>
      <div className='Navbar'>
        <div className='NavLogo'>
          <img src={Logo} alt='logo' width='120px'></img>
        </div>
        <div className='NavText'>
        {window.innerWidth > 786 ? <ul>
          <li className='active'><Link to='/'>Home</Link></li>
          <li><a href='#ActivitySection'>Activity</a></li>
          <li><a href='#AboutSection'>About</a></li>
          <li><a href='#Diagnose'>Diagnose</a></li>
          <li><a href='#ModelInfo'>Model Info</a></li>
        </ul>:<ul>
          <img src={Navbutton} width='30px' height='26px' onClick={()=>this.handleTab()}></img>
        </ul>}
        </div>
      </div>
      {this.state.tab ? <div>
          <ul className='MobileList'>
          <li onClick={()=>this.handleTab()}><a href='#ActivitySection'>Activity</a></li>
          <li onClick={()=>this.handleTab()}><a href='#AboutSection'>About</a></li>
          <li onClick={()=>this.handleTab()}><a href='#Diagnose'>Diagnose</a></li>
          <li onClick={()=>this.handleTab()}><a href='#ModelInfo'>Model Info</a></li>
          </ul>
        </div>:<></>}
      </>
    )
  }
}
